import { render } from "./SolutionsSteps.vue?vue&type=template&id=5d348e69&lang=pug"
const script = {}

import "./SolutionsSteps.vue?vue&type=style&index=0&id=5d348e69&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__